/**
 * List of endpoints.
 */
export const endpoints = {
  CLAIMS: '/api/claims',
  CLAIM_ID: '/api/claims/:id',
};
